// extracted by mini-css-extract-plugin
module.exports = {"CategoryCardWrapper":"CategoryCard_CategoryCardWrapper__J9AIv","TitleCategory":"CategoryCard_TitleCategory__t3E0f"};